export class StringExtension {
  isEmpty = (value: string): boolean => {
    return value.trim().length === 0;
  };
  isEquals = (value: string, compareValue: string): boolean => {
    return value.trim().toLowerCase() === compareValue.trim().toLowerCase();
  };
}
